<iframe #iFrame style="display: none" src="about:blank"></iframe>
